import React from 'react';
import { Button, Result } from 'antd';
import { logout } from 'myredux/loginSlice';
import { useDefault } from 'hooks/useDefault';

const Error500: React.FC = () => {
    const { navigation, dispatch } = useDefault();

    return <Result
        status="500"
        title="500"
        subTitle="Něco se u nás pokazilo. Zkuste přejít na domovskou stránku."
        extra={<><Button type="primary" onClick={() => navigation('/secured/homepage')}>Domovská stránka</Button><Button type="primary" onClick={() => dispatch(logout())}>Odhlásit se</Button></>}
    />
};

export default Error500;